export const UserURL = {
    USER_DASHBOARD: '/user/dashboard',

    USER_BUSINESS_HUB: '/user/busines/:id',
    user_business_hub: (id) => `/user/busines/${id}`,

    USER_INVOICE_DASHBOARD: '/user/invoices',
    USER_CREATE_MANUAL_ENTRY: '/user/invoices/create-manual',

    USER_INVOICE_EDIT: '/user/busines/:businessId/invoices/:invoiceId/edit',
    user_invoice_edit: (businessId, invoiceId) => `/user/busines/${businessId}/invoices/${invoiceId}/edit`,
}
